import "../../assets/css/authentication/form-1.css"
import "../../assets/css/forms/switches.css"
import "../../assets/css/forms/theme-checkbox-radio.css"
import LoginForm from "./LoginForm"

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

interface childsProps {
    authenticated: boolean
    restablecer: boolean
}

const Login: React.FC<childsProps> = ({ authenticated, restablecer }) => {

    const navigate = useNavigate()
    
    useEffect(() => {
        if (restablecer)
            navigate("/restablecer")
        else if(authenticated) {
            navigate("/home")
        }
    }, [restablecer, navigate, authenticated])


    return (

        <>
            <div className="form backgroundWhiteLogin">
                <div className="form-container">
                    <div className="form-form">
                        <div className="form-form-wrap">
                            <div className="form-container">
                                <div className="form-content">

                                    <h1 className="">Bienvenido a <a href="index.html"><span className="brand-name">Exactocarga</span></a></h1>


                                    <LoginForm/>
                                    <div className="d-flex justify-content-center mt-4 d-flex flex-column text-center">
                                        {/* <Link className="text-primary mt-1 mb-1" to={"/home/consulta/guia"}>Consultar Guias como invitado</Link>
                                        <Link className="text-primary mt-1 mb-1" to={"/home/consulta/resumenGuias"}>Consultar Resumen de Guias</Link> */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-image">
                        <div className="l-image">
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Login